import React from "react";
import Footer from "../Footer/Footer";
import "./Home.css"; 
import HomeFirstSection from "./HomeFirstSection/HomeFirstSection";
import InfoBtnsSection from "./InfoBtnsSection/InfoBtnsSection";
import MediaSection from "./MediaSection/MediaSection";
import TrajectorySection from "./TrajectorySection/TrajectorySection";
import TopClientsSection from "./TopClientsSection/TopClientsSection"; 
import ServicesSection from "./ServicesSection/ServicesSection";

const Home = () => {
  return (
    <div className="home-container">
      <HomeFirstSection className="home-page-container"/>
      <InfoBtnsSection className="info-btns-section"/>
      <MediaSection className="media-section"/>
      <ServicesSection className="services-section"/>
      <TrajectorySection className="trajectory-section"/>
      <TopClientsSection className="top-clients-section"/>
      <Footer />
    </div>
  );
};

export default Home;